import { PatientSkillAcqActiveProgramListActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  loadingTargets: false,
  patientSkillAcqActiveProgramList: null,
  patientSkillAcqAppointmentDetailsList: null,
  uuid: null,
  openTarget: false,
  ProgramIds: null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case PatientSkillAcqActiveProgramListActionTypes.get_patientSkillAcqActiveProgramList.REQUEST:
      return {
        ...state,
        loading: true,
        patientSkillAcqActiveProgramList: null,
      };
    case PatientSkillAcqActiveProgramListActionTypes.get_patientSkillAcqActiveProgramList.SUCCESS:
      return {
        ...state,
        loading: false,
        patientSkillAcqActiveProgramList: payload,
      };
      case PatientSkillAcqActiveProgramListActionTypes.get_patientSkillAcqAppointmentDetailsList.REQUEST:
      return {
        ...state,
        loading: true,
        patientSkillAcqAppointmentDetailsList: null,
      };
    case PatientSkillAcqActiveProgramListActionTypes.get_patientSkillAcqAppointmentDetailsList.SUCCESS:
      return {
        ...state,
        loading: false,
        patientSkillAcqAppointmentDetailsList: payload,
      };
    case PatientSkillAcqActiveProgramListActionTypes.set_uuid.SUCCESS:
      return {
        ...state,
        loading: false,
        uuid: payload,
      };
    case PatientSkillAcqActiveProgramListActionTypes.set_openTarget.SUCCESS:
      return {
        ...state,
        loading: false,
        openTarget: payload,
      };
    case PatientSkillAcqActiveProgramListActionTypes.set_ProgramIds.SUCCESS:
      return {
        ...state,
        loading: false,
        ProgramIds: payload,
      };
    case PatientSkillAcqActiveProgramListActionTypes.reset_ProgramAndtarget.SUCCESS:
      return {
        ...state,
        loading: false,
        openTarget: false,
        ProgramIds: null,
      };
      case PatientSkillAcqActiveProgramListActionTypes.set_ProgramForSKillAxqTargetApplicationState.SUCCESS:
        return {
          ...state,
          ProgramIdsForTargetListingApplicationState: payload
        };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/programs/reducers/programsReducer.js